export default __webpack_public_path__ + "static/media/Legguards of the Inconceivable.258ade62.jpg";